/* Siestín · Manta calefactable — scripts propios (prefijo sm-) */
(function () {
  'use strict';
  if (window.__smIniciado) return;
  window.__smIniciado = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function formatoDinero(cents) {
    var euros = (cents / 100).toFixed(2).replace('.', ',');
    return euros.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' €';
  }

  function initReveal() {
    var els = document.querySelectorAll('.sm-reveal:not(.sm-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('sm-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('sm-visible'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  var cuentaTimer = null;
  function initCuentas() {
    var cuentas = document.querySelectorAll('[data-sm-cuenta]');
    if (!cuentas.length) return;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var ahora = Date.now();
      cuentas.forEach(function (c) {
        var fin = Date.parse(c.getAttribute('data-sm-cuenta'));
        var cont = c.closest('[data-sm-cuenta-wrap]') || c;
        if (isNaN(fin) || fin - ahora <= 0) { cont.hidden = true; return; }
        var s = Math.floor((fin - ahora) / 1000);
        var d = Math.floor(s / 86400); s -= d * 86400;
        var h = Math.floor(s / 3600); s -= h * 3600;
        var m = Math.floor(s / 60); s -= m * 60;
        var set = function (k, v) { var el = c.querySelector('[data-' + k + ']'); if (el) el.textContent = v; };
        set('d', pad(d)); set('h', pad(h)); set('m', pad(m)); set('s', pad(s));
        cont.hidden = false;
      });
    }
    tick();
    if (cuentaTimer) clearInterval(cuentaTimer);
    cuentaTimer = setInterval(tick, 1000);
  }

  function initTilt() {
    var marcos = document.querySelectorAll('[data-sm-tilt]');
    if (!marcos.length || reduce || !window.matchMedia('(hover: hover)').matches) return;
    marcos.forEach(function (m) {
      var zona = m.closest('section') || m;
      zona.addEventListener('mousemove', function (e) {
        var r = m.getBoundingClientRect();
        var x = (e.clientX - (r.left + r.width / 2)) / r.width;
        var y = (e.clientY - (r.top + r.height / 2)) / r.height;
        m.style.setProperty('--sm-ry', (x * 10).toFixed(2) + 'deg');
        m.style.setProperty('--sm-rx', (-y * 8).toFixed(2) + 'deg');
      });
      zona.addEventListener('mouseleave', function () { m.style.removeProperty('--sm-ry'); m.style.removeProperty('--sm-rx'); });
    });
  }

  function initNiveles() {
    document.querySelectorAll('[data-sm-niveles]').forEach(function (root) {
      if (root.__sm) return; root.__sm = true;
      var botones = root.querySelectorAll('.sm-nivel');
      var temp = root.querySelector('[data-sm-temp]');
      var nombre = root.querySelector('[data-sm-temp-nombre]');
      var aura = root.querySelector('.sm-niveles__aura');
      var auto = null;
      function activar(btn) {
        botones.forEach(function (b) { b.classList.toggle('is-activo', b === btn); b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        if (temp) temp.textContent = btn.getAttribute('data-grados');
        if (nombre) nombre.textContent = btn.getAttribute('data-nombre');
        if (aura) aura.style.setProperty('--sm-aura', btn.getAttribute('data-aura'));
      }
      botones.forEach(function (b) { b.addEventListener('click', function () { if (auto) { clearInterval(auto); auto = null; } activar(b); }); });
      if (!botones.length) return;
      var i = botones.length > 1 ? 1 : 0;
      activar(botones[i]);
      if (!reduce && botones.length > 1 && root.hasAttribute('data-sm-auto')) {
        auto = setInterval(function () { i = (i + 1) % botones.length; activar(botones[i]); }, 2800);
      }
    });
  }

  function initProducto() {
    var root = document.querySelector('[data-sm-producto]');
    if (!root || root.__sm) return;
    root.__sm = true;
    var datosEl = root.querySelector('[data-sm-variantes]');
    var variantes = [];
    try { variantes = JSON.parse(datosEl.textContent); } catch (e) {}
    var form = root.querySelector('[data-sm-form]');
    if (!form) return;
    var inputId = form.querySelector('input[name="id"]');
    var inputQty = form.querySelector('input[name="quantity"]');
    var boton = root.querySelector('[data-sm-boton]');
    var botonTxt = boton ? boton.querySelector('[data-sm-boton-txt]') : null;
    var textoBase = botonTxt ? botonTxt.textContent : '';
    var error = root.querySelector('[data-sm-error]');
    var principal = root.querySelector('[data-sm-principal]');
    var minis = root.querySelectorAll('.sm-prod__mini');
    var barra = root.querySelector('[data-sm-barra]');

    var idx = 0;
    minis.forEach(function (m, i) { if (m.classList.contains('is-activa')) idx = i; });
    function mostrar(i) {
      if (!minis.length || !principal) return;
      idx = (i + minis.length) % minis.length;
      var mini = minis[idx];
      minis.forEach(function (m) { m.classList.toggle('is-activa', m === mini); });
      principal.classList.add('is-cambiando');
      var nuevo = new Image();
      nuevo.onload = function () {
        principal.removeAttribute('srcset');
        principal.src = nuevo.src;
        principal.alt = mini.getAttribute('data-alt') || '';
        principal.classList.remove('is-cambiando');
      };
      nuevo.src = mini.getAttribute('data-src');
    }
    minis.forEach(function (m, i) { m.addEventListener('click', function () { mostrar(i); }); });
    var izq = root.querySelector('[data-sm-prev]');
    var der = root.querySelector('[data-sm-next]');
    if (izq) izq.addEventListener('click', function () { mostrar(idx - 1); });
    if (der) der.addEventListener('click', function () { mostrar(idx + 1); });
    if (principal) {
      var x0 = null;
      principal.parentElement.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      principal.parentElement.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) mostrar(idx + (dx < 0 ? 1 : -1));
        x0 = null;
      });
    }

    function varianteActual() {
      var valores = [];
      root.querySelectorAll('[data-sm-opcion]:checked').forEach(function (m) { valores[parseInt(m.getAttribute('data-pos'), 10)] = m.value; });
      for (var i = 0; i < variantes.length; i++) {
        var v = variantes[i], ok = true;
        for (var j = 0; j < valores.length; j++) { if (valores[j] !== undefined && v.options[j] !== valores[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return variantes[0];
    }
    function packActual() {
      var p = root.querySelector('[data-sm-pack]:checked');
      if (!p) return { qty: 1, desc: 0 };
      return { qty: parseInt(p.value, 10) || 1, desc: parseInt(p.getAttribute('data-desc'), 10) || 0 };
    }
    function base(v) { return (v.compare_at_price && v.compare_at_price > v.price) ? v.compare_at_price : v.price; }

    function actualizar(cambiarFoto) {
      var v = varianteActual();
      if (!v) return;
      var pack = packActual();
      inputId.value = v.id;
      inputQty.value = pack.qty;
      var total = v.price * pack.qty - pack.desc;
      var antes = base(v) * pack.qty;
      root.querySelectorAll('[data-sm-pack]').forEach(function (p) {
        var q = parseInt(p.value, 10) || 1;
        var d = parseInt(p.getAttribute('data-desc'), 10) || 0;
        var t = v.price * q - d;
        var a = base(v) * q;
        var card = p.closest('.sm-pack');
        card.classList.toggle('is-activo', p.checked);
        var b = card.querySelector('[data-sm-pack-total]'); if (b) b.textContent = formatoDinero(t);
        var s = card.querySelector('[data-sm-pack-antes]'); if (s) s.textContent = a > t ? formatoDinero(a) : '';
        var u = card.querySelector('[data-sm-pack-ud]'); if (u && q > 1) u.textContent = formatoDinero(Math.round(t / q)) + '/ud';
      });
      root.querySelectorAll('[data-sm-opcion]').forEach(function (o) { var lab = o.closest('.sm-color'); if (lab) lab.classList.toggle('is-activo', o.checked); });
      root.querySelectorAll('[data-sm-valor-elegido]').forEach(function (el) {
        var marcado = root.querySelector('[data-sm-opcion][data-pos="' + el.getAttribute('data-sm-valor-elegido') + '"]:checked');
        if (marcado) el.textContent = marcado.value;
      });
      root.querySelectorAll('[data-sm-precio]').forEach(function (el) { el.textContent = formatoDinero(total); });
      root.querySelectorAll('[data-sm-precio-antes]').forEach(function (el) { el.textContent = antes > total ? formatoDinero(antes) : ''; });
      var pct = antes > total ? Math.round((1 - total / antes) * 100) : 0;
      root.querySelectorAll('[data-sm-ahorro]').forEach(function (el) {
        el.hidden = pct <= 0;
        el.textContent = (el.getAttribute('data-plantilla') || '-[pct]%').replace('[pct]', pct).replace('[euros]', formatoDinero(antes - total));
      });
      if (boton) {
        boton.disabled = !v.available;
        if (botonTxt) botonTxt.textContent = v.available ? textoBase : (boton.getAttribute('data-agotado') || 'Agotado');
      }
      if (cambiarFoto && v.featured_media_id) {
        for (var k = 0; k < minis.length; k++) { if (minis[k].getAttribute('data-id') === String(v.featured_media_id)) { mostrar(k); break; } }
      }
      if (variantes.length > 1 && window.history && window.history.replaceState) {
        try { var url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url.toString()); } catch (e) {}
      }
    }
    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-sm-opcion]')) actualizar(true);
      else if (e.target.matches('[data-sm-pack]')) actualizar(false);
    });
    try {
      var qp = new URLSearchParams(window.location.search).get('pack');
      if (qp) { var r = root.querySelector('[data-sm-pack][value="' + qp + '"]'); if (r) r.checked = true; }
    } catch (e) {}
    actualizar(false);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (boton && boton.disabled) return;
      if (error) error.style.display = 'none';
      if (boton) boton.classList.add('is-cargando');
      if (botonTxt) botonTxt.textContent = boton.getAttribute('data-cargando') || 'Añadiendo…';
      var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
      fetch(raiz + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(inputId.value, 10), quantity: parseInt(inputQty.value, 10) || 1 }] })
      }).then(function (r) {
        return r.json().then(function (d) { if (!r.ok) throw d; return d; });
      }).then(function () {
        window.location.href = form.getAttribute('data-destino') || (raiz + 'cart');
      }).catch(function (err) {
        if (boton) boton.classList.remove('is-cargando');
        if (botonTxt) botonTxt.textContent = textoBase;
        if (error) { error.textContent = (err && (err.description || err.message)) || 'No se pudo añadir. Inténtalo de nuevo.'; error.style.display = 'block'; }
      });
    });

    if (barra && boton && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        var e0 = en[0];
        barra.classList.toggle('is-visible', !e0.isIntersecting && e0.boundingClientRect.top < 0);
      });
      io.observe(boton);
      var bb = barra.querySelector('[data-sm-barra-btn]');
      if (bb) bb.addEventListener('click', function (e) {
        e.preventDefault();
        if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
      });
    }
  }

  function init() { initReveal(); initCuentas(); initTilt(); initNiveles(); initProducto(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { initReveal(); initCuentas(); initNiveles(); });
})();